import { type ReactNode, type ReactElement } from 'react';
import cn from 'classnames';

import styles from './tile.module.scss';

interface ITileFooterProps {
  children?: ReactNode,
  className?: string,
  dataTest?: string,
}

const TileFooter = ({ children, className, dataTest }: ITileFooterProps): ReactElement => (
  <div className={ cn(styles.footer, className) } data-test={ dataTest }>
    { children }
  </div>
);

export { TileFooter };
export type { ITileFooterProps };
